<script>
import sidebarLinksData from '@/sidebarLinks.json';
import HeightTransition from '@/components/UIKit/HeightTransition.vue';
import request from '@/services/request';


export default {
    components: { HeightTransition },
    data() {
        return {
            show: true,
            showGroup: false,
            filteredLinks: [],
        };
    },
    methods: {
        getEndpoints() {
            request.get(`/endpoint/all/active/by-token`)
                .then((res) => {
                    if (res.data.success) {
                        let paths = [];

                        res.data.message.forEach((el) => {
                            paths.push(el.path);
                        })
                        this.$store.commit('setPermittedPaths', paths);
                    } else {
                        alert('Маршруты не загрузились');
                    }
                })

        },
        setFilteredLinks() {
            this.filteredLinks = sidebarLinksData.filter((link) => {
                if (!link.accessPath) return true;
                return link.accessPath.some((role) =>
                    this.$store.getters.getPermittedPaths.includes(role)
                );
            });

            this.filteredLinks.forEach((link) => {
                if (link.type !== 'group') {
                    if (!this.$router.hasRoute(link.name)) {
                        this.$router.addRoute({
                            path: link.route,
                            name: link.name,
                            component: () => import(`@/views/${link.component}.vue`),
                        });
                    }
                } else {
                    this.$router.addRoute({
                        path: link.route,
                        name: link.name,
                        component: () => import(`@/views/${link.component}.vue`),
                    });

                    link.items.forEach((el) => {
                        if (!this.$router.hasRoute(el.name)) {
                            this.$router.addRoute({
                                path: el.route,
                                name: el.name,
                                component: () => import(`@/views/${el.component}.vue`),
                            });
                        }
                    });
                }
            });

            if (this.filteredLinks[0]) {
                this.$router.push(window.location.pathname);
            }
        },
        toggle() {
            this.$store.commit('toggleSidebar');
        },
        getStatus() {
            return this.$store.state.showSidebar;
        },
        toggleGroup(el) {
            this.filteredLinks.forEach((item) => {
                if (item.name === el.name) {
                    item.isOpen = !item.isOpen;
                }
            });
        },
        isGroupActive(group) {
            return group.items.some(item => this.$route.path === item.route);
        },
    },
    watch: {
        '$store.getters.getPermittedPaths'(oldVal, newVal) {
            if (oldVal !== newVal) {
                this.setFilteredLinks();
            }
        }
    },
    mounted() {
        this.getEndpoints();
    }
};
</script>

<template>
    <aside
        :class="{
            'translate-x-0': getStatus(),
            '-translate-x-[80rem]': !getStatus(),
        }"
        class="fixed inset-0 z-50 flex h-[100vh] w-[280px] flex-col bg-gray-800 shadow-lg transition-transform duration-300">
<!--        <div class="relative border-b-2 border-white/20">-->
<!--            <div class="flex w-full flex-col items-center gap-2 py-4">-->
<!--                //logo-->
<!--            </div>-->
<!--        </div>-->
        <div class="custom-scroll mb-6 pl-4 mt-4 pr-3">
            <ul class="mb-4 flex flex-col gap-3">
                <li :key="el.id" v-for="el in filteredLinks" class="border-gray-400">
                    <router-link v-if="el.type === 'link'" :to="el.route">
                        <div
                            class="middle none center flex w-full items-center gap-4 rounded-lg px-4 py-3 font-sans text-xs font-bold capitalize text-white transition-all hover:bg-white/10 active:bg-white/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
                            <div v-html="el.svg" />
                            <p class="block font-sans text-sm font-medium capitalize leading-relaxed text-inherit antialiased">
                                {{ $t(el.name) }}
                            </p>
                        </div>
                    </router-link>

                    <div v-if="el.type === 'group'" class="flex flex-col relative">
                        <router-link :to="el.route">
                            <div
                                :class="{'outline': isGroupActive(el) && !el.isOpen}"
                                class="justify-between outline-2 outline-indigo-500 hover:bg-white/10 middle none center flex w-full items-center gap-4 rounded-lg px-4 py-3 font-sans text-xs font-bold capitalize text-white transition-all disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
                                <div class="flex gap-4">
                                    <div v-html="el.svg" />
                                    <p class="block font-sans text-sm font-medium capitalize leading-relaxed antialiased whitespace-nowrap">
                                        {{ $t(el.name) }}
                                    </p>
                                </div>

                                <div @click.prevent="toggleGroup(el)"
                                     class="shake-container flex min-w-[30px] w-[25px] h-[25px] rounded-md hover:bg-white/10 justify-center items-center">
                                    <svg
                                        :class="{
                                            'rotate-180': el.isOpen,
                                            'shake': isGroupActive(el) && !el.isOpen,
                                        }"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                        class="w-4 h-4 transition-all">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                              d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                                    </svg>
                                </div>
                            </div>
                        </router-link>

                        <HeightTransition class="transition-all">
                            <div v-if="el.isOpen"
                                 class=" relative pl-10 flex gap-1 flex-col w-full overflow-hidden">
                                <div class="absolute w-[1px] h-[calc(100%_-_22px)] top-0 bg-white left-[25px]"></div>
                                <router-link
                                    :to="item.route"
                                    :key="item.id"
                                    v-for="item in el.items"
                                    class="group relative middle none center flex w-full items-center gap-4 rounded-lg px-4 py-3 font-sans text-xs font-bold text-white transition-all hover:bg-white/10 active:bg-white/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
                                    <div
                                        class="absolute w-[15px] h-[0.5px] bg-white top-1/2 left-[-14px] -translate-y-1/2" />
                                    <p class="block font-sans text-sm font-medium leading-relaxed text-inherit text-white antialiased text-left">
                                        {{ $t(item.name) }}
                                    </p>
                                </router-link>
                            </div>
                        </HeightTransition>
                    </div>
                </li>
            </ul>
        </div>
    </aside>
</template>

<style>
.shake {
    display: inline-block;
    animation: shake 1s ease-in-out 1s infinite;
    animation-fill-mode: forwards;
}

.shake-container:hover > .shake {
    animation-iteration-count: 1;
}

@keyframes shake {
    0% {
        transform: translateY(0);
    }
    20% {
        transform: translateY(-4px);
    }
    40% {
        transform: translateY(4px);
    }
    60% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(0);
    }
}
</style>